document.addEventListener('DOMContentLoaded', () => {
  $('.form__spoiler').on('click', function () {
    $(this).toggleClass('is-open')
  })
})
